@if (release.availableRelease()) {
  <aside class="app-update-notice" role="status">
    <span>
      @if (release.displayVersion(); as version) {
        {{ 'Version [version] is available.' | translate: { version } }}
      } @else {
        {{ 'A new version is available.' | translate }}
      }
    </span>
    <div class="actions">
      <button type="button" [disabled]="!canReload()" (click)="reload()">
        {{ 'Reload' | translate }}
      </button>
      <a [href]="patchNotesUrl" target="_blank" rel="noopener noreferrer">
        {{ 'Patch notes' | translate }}
      </a>
    </div>
  </aside>
}
